// File: src/pages/ProductionProcess.jsx
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Form,
  Row,
  Label,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Multiselect from "multiselect-react-dropdown";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// --- all app APIs & helpers live under ../import/ per your instructions
import {
  ProductListView,
  UnitListView,
  WarehousetoWareHouseTrx,
  _PostSave,
} from "../import/ApiEndPoint/ApiCalling";
import { Save_Producton_Process } from "../import/ApiEndPoint/Api";

let GrandTotal = [];
let SelectedITems = [];
let SelectedSize = [];

const StartProductionProcess = (args) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [ExtraCharges, setExtraCharges] = useState({
    Other_Expenses: 100,
    GSTApplied: 18,
    Other_charges: 50,
    discount: 10, // currently not subtracted, matching your original logic
  });

  const [Index, setIndex] = useState("");
  const [StockTrxdate, setStockTrxDate] = useState("");
  const [index, setindex] = useState("");
  const [error, setError] = useState("");

  const [ProductList, setProductList] = useState([]);
  const [itemList, setitemList] = useState([]);
  const [ProductWTWList, setProductWTWList] = useState([]);
  const [ProductinProduct, setProductionProduct] = useState({});
  const [WareHousetwo, setWareHousetwo] = useState([]);
  const [grandTotalAmt, setGrandTotalAmt] = useState(0);
  const [UnitList, setUnitList] = useState([]);
  const [UserInfo, setUserInfo] = useState({});

  const [modalOne, setModalOne] = useState(false);
  const toggleOne = () => setModalOne(!modalOne);

  const [product, setProduct] = useState([
    {
      product: "",
      productId: "",
      selecetedUnit: "",
      WasteUnit: "",
      AvailaleQty: null,
      Waste_Qty: null,
      WastePrice: "",
      availableQty: "",
      transferQty: 1,
      RequiredQty: "",
      price: "",
      totalprice: "",
      Size: "",
      unitType: "",
      stockTrxDate: "",
      targetEndDate: "",
      discount: "",
      Shipping: "",
      tax: "",
      grandTotal: "",
    },
  ]);

  const handleExtraCharge = (e) => {
    const { name, value } = e.target;
    setExtraCharges((p) => ({ ...p, [name]: value }));
  };

  const handleProductChangeProduct = (e, idx, avalaibleSize) => {
    if (avalaibleSize >= Number(e.target.value)) {
      setIndex(idx);
      const { name, value } = e.target;
      const list = [...product];

      if (name.includes("transferQty")) {
        const available = Number(list[idx]["AvailaleQty"]);
        const asking = Number(value);
        if (available >= asking) {
          list[idx][name] = asking;
        } else {
          swal("Can not Transfer More than Stock");
          list[idx][name] = Math.max(available - 1, 0);
        }
      } else {
        list[idx][name] = value;
      }

      let amt = 0;
      if (list.length > 0) {
        const parts = list.map((val, i) => {
          const t =
            Number(val.Size || 0) *
            Number(val.price || 0) *
            Number(val.transferQty || 0);
          GrandTotal[i] = t;
          list[i]["totalprice"] = t;
          return t;
        });
        amt = parts.reduce((a, b) => a + b, 0);
      }

      setProduct(list);
      setGrandTotalAmt(amt);
    }
  };

  const handleProductChangeProductTwo = (e, idx) => {
    setIndex(idx);
    const { name, value } = e.target;
    const list = [...product];
    list[idx][name] = value;
    setProduct(list);
  };

  const handleProductChangeProductone = (e, idx) => {
    setIndex(idx);
    const { name, value } = e.target;
    const list = [...product];
    list[idx][name] = Number(value);

    let amt = 0;
    if (list.length > 0) {
      const parts = list.map((val, i) => {
        const t = Number(val.price || 0) * Number(val.RequiredQty || 0);
        GrandTotal[i] = t;
        list[i]["totalprice"] = t;
        return t;
      });
      amt = parts.reduce((a, b) => a + b, 0);
    }
    setProduct(list);
    setGrandTotalAmt(Number.isFinite(amt) ? amt.toFixed(2) : 0);
  };

  const handleRemoveSelected = (selectedList, selectedItem, idx) => {
    SelectedITems.splice(idx, 1);
    const parts = product.map((ele, i) => {
      const t =
        Number(ele?.qty || 0) * Number(SelectedITems[i]?.Product_MRP || 0);
      GrandTotal[i] = t;
      return t;
    });
    const amt = parts.reduce((a, b) => a + b, 0);
    setGrandTotalAmt(amt);
  };

  const handleRemoveSelectedone = (selectedList, selectedItem, idx) => {
    SelectedSize.splice(idx, 1);
    const parts = product.map((ele, i) => {
      const t = Number(ele?.Size || 0) * Number(SelectedSize[i]?.unitQty || 0);
      GrandTotal[i] = t;
      return t;
    });
    const amt = parts.reduce((a, b) => a + b, 0);
    setGrandTotalAmt(amt);
  };

  const handleSelectionProduct = (selectedList, selectedItem, idx) => {
    SelectedITems.push(selectedItem);
    setProduct((prev) => {
      const list = [...prev];
      const updated = { ...list[idx] };
      updated.price = selectedItem?.Product_MRP;
      updated.productId = selectedItem?._id;
      if (selectedItem?.unitType) {
        updated.unitType = selectedItem?.unitType.split(" ")[1];
      }
      list[idx] = updated;
      return list;
    });
  };

  const handleSelectionone = (selectedList, selectedItem, idx) => {
    SelectedSize.push(selectedItem);
    setProduct((prev) => {
      const list = [...prev];
      const updated = { ...list[idx] };
      updated.Size = selectedItem?.unitQty;
      updated.unitType = selectedItem?.primaryUnit;
      list[idx] = updated;

      const totals = list.map((ele, i) => {
        const t =
          Number(ele?.transferQty || 0) *
          Number(ele?.price || 0) *
          Number(SelectedSize[i]?.unitQty || 0);
        GrandTotal[i] = t;
        return t;
      });
      const amt = totals.reduce((a, b) => a + b, 0);
      setGrandTotalAmt(amt);

      return list;
    });
  };

  const handleInputChange = (e, type, i) => {
    const { name, value, checked } = e.target;
    setindex(i);
    if (type === "checkbox") {
      setFormData((p) => ({ ...p, [name]: !!checked }));
      return;
    }
    if (type === "number") {
      if (/^\d{0,10}$/.test(value)) {
        setFormData((p) => ({ ...p, [name]: value }));
        setError("");
      } else {
        setError(
          "Please enter a valid number with a maximum length of 10 digits"
        );
      }
      return;
    }
    if (value.length <= 10) {
      setFormData((p) => ({ ...p, [name]: value }));
      setError("");
    } else {
      setFormData((p) => ({ ...p, [name]: value }));
    }
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");

    UnitListView(userData?._id, userData?.database)
      .then((res) => setUnitList(Array.isArray(res?.Unit) ? res.Unit : []))
      .catch(() => {});

    ProductListView(userData?._id, userData?.database)
      .then((res) => {
        const list = Array.isArray(res?.Product) ? res.Product : [];
        setitemList(list);
        setProductList(list);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");
    setUserInfo(userInfo);
  }, []);

  const addMoreProduct = () => {
    setProduct((prev) => [
      ...prev,
      {
        product: "",
        productId: "",
        selecetedUnit: "",
        WasteUnit: "",
        AvailaleQty: null,
        Waste_Qty: null,
        WastePrice: "",
        availableQty: "",
        transferQty: 1,
        RequiredQty: "",
        price: "",
        totalprice: "",
        Size: "",
        unitType: "",
        stockTrxDate: "",
        targetEndDate: "",
        discount: "",
        Shipping: "",
        tax: "",
        grandTotal: "",
      },
    ]);
  };

  const removeMoreProduct = (i) => {
    const list = [...product];
    list.splice(i, 1);
    if (GrandTotal?.length) {
      GrandTotal.splice(i, 1);
      const amt = GrandTotal.reduce((a, b) => a + b, 0);
      setGrandTotalAmt(amt);
    }
    setProduct(list);
  };

  const handleAddCharges = (e) => {
    e.preventDefault();
    toggleOne();
  };

  const submitHandler = (e) => {
    e.preventDefault();

    const userdata = JSON.parse(localStorage.getItem("userData") || "{}");

    const Allproduct = product.map((ele) => ({
      productId: ele?.productId,
      unit: ele?.unitType,
      price: ele?.price,
      qty: ele?.RequiredQty,
      unitType: ele?.selecetedUnit,
      totalPrice: Number(ele?.price || 0) * Number(ele?.RequiredQty || 0),
    }));

    const AllWastage = product.map((ele) => ({
      productId: ele?.productId,
      unit: ele?.WasteUnit,
      price: ele?.price,
      qty: ele?.Waste_Qty,
      unitType: ele?.WasteUnit,
      totalPrice: Number(ele?.price || 0) * Number(ele?.Waste_Qty || 0),
    }));

    const ALL =
      Number(grandTotalAmt || 0) +
      Number(ExtraCharges?.Other_Expenses || 0) +
      Number(ExtraCharges?.Other_charges || 0) +
      (Number(grandTotalAmt || 0) * Number(ExtraCharges?.GSTApplied || 0)) /
        100;

    const payload = {
      created_by: userdata?._id,
      product_name: ProductinProduct?._id,
      productItems: Allproduct,
      wastageItems: AllWastage,
      miscellaneousExpennses: ExtraCharges?.Other_Expenses,
      gstApplied: ExtraCharges?.GSTApplied,
      otherCharges: ExtraCharges?.Other_charges,
      // discount: ExtraCharges?.discount, // kept as in original (commented)
      grandTotal: ALL,
    };

    _PostSave(Save_Producton_Process, payload)
      .then(() => {
        toggleOne();
        swal("Production Process is Started");
      })
      .catch(() => {});
  };

  const onSelect1 = (selectedList) => {
    setProductionProduct(selectedList[0]);
  };
  const onRemove1 = () => {};

  const onSelectone = (selectedList) => {
    setProductionProduct(selectedList);
    const products = selectedList?.[0]?.productItems || [];
    const mapped = products.map((ele) => {
      const myproduct = ele?.productId || {};
      ele["Product_Title"] = myproduct?.Product_Title;
      ele["Product_id"] = myproduct?._id;
      ele["Product_MRP"] = myproduct?.Product_MRP;
      ele["transferQty"] = myproduct?.transferQty;
      ele["MIN_stockalert"] = myproduct?.MIN_stockalert;
      return ele;
    });
    setProductWTWList(mapped);
  };
  const onRemoveone = () => {};

  const onSelect2 = (selectedList) => setWareHousetwo(selectedList);
  const onRemove2 = () => {};

  return (
    <div>
      <Card>
        <Row className="m-2">
          <Col lg="8" md="8" sm="8" className="mb-2 mt-1">
            <h1 className="m-0">Start Production Process</h1>
          </Col>
          <Col className="d-flex align-items-center justify-content-end">
            <Button color="primary" onClick={() => navigate(-1)}>
              Back
            </Button>
          </Col>
        </Row>

        <CardBody>
          <Form className="m-1" onSubmit={handleAddCharges}>
            <Row>
              <Col className="mb-1" lg="3" md="4" sm="12">
                <Label>Choose Production Product</Label>
                <Multiselect
                  required
                  selectionLimit={1}
                  isObject
                  options={ProductList}
                  onSelect={onSelect1}
                  onRemove={onRemove1}
                  displayValue="Product_Title"
                />
              </Col>
            </Row>

            {product.map((row, i) => (
              <Row key={i}>
                <Col className="mb-1" lg="3" md="4" sm="12">
                  <Label>Choose Item *</Label>
                  <Multiselect
                    required
                    selectionLimit={1}
                    isObject
                    options={itemList}
                    onSelect={(list, item) =>
                      handleSelectionProduct(list, item, i)
                    }
                    onRemove={(list, item) =>
                      handleRemoveSelected(list, item, i)
                    }
                    displayValue="Product_Title"
                  />
                </Col>

                <Col className="mb-1" lg="2" md="3" sm="12">
                  <Label>Select Unit</Label>
                  <select
                    required
                    className="form-control"
                    name="selecetedUnit"
                    value={row?.selecetedUnit || ""}
                    onChange={(e) => handleProductChangeProductTwo(e, i)}
                  >
                    <option value="">--select Unit--</option>
                    <option value="kg">Kilogram (kg)</option>
                    <option value="Pcs">Pieces (Pcs)</option>
                    <option value="g">Gram (g)</option>
                    <option value="tonne">Metric Ton (tonne)</option>
                    <option value="m">Meter (m)</option>
                    <option value="cm">Centimeter (cm)</option>
                    <option value="mm">Millimeter (mm)</option>
                    <option value="in">Inch (in)</option>
                    <option value="ft">Foot (ft)</option>
                    <option value="m3">Cubic Meter (m³)</option>
                    <option value="L">Liter (L)</option>
                    <option value="ml">Milliliter (ml)</option>
                    <option value="s">Second (s)</option>
                    <option value="min">Minute (min)</option>
                    <option value="hr">Hour (hr)</option>
                    <option value="°C">Celsius (°C)</option>
                    <option value="°F">Fahrenheit (°F)</option>
                    <option value="Pa">Pascal (Pa)</option>
                    <option value="bar">Bar (bar)</option>
                    <option value="m/s">Meters per Second (m/s)</option>
                    <option value="km/h">Kilometers per Hour (km/h)</option>
                    <option value="A">Ampere (A)</option>
                    <option value="V">Volt (V)</option>
                    <option value="W">Watt (W)</option>
                    <option value="kW">Kilowatt (kW)</option>
                  </select>
                </Col>

                <Col className="mb-1" lg="2" md="3" sm="12">
                  <Label>
                    Price{row?.unitType ? ` (${row.unitType})` : ""}
                  </Label>
                  <Input
                    type="number"
                    name="price"
                    readOnly
                    value={row.price || ""}
                    onChange={(e) => handleProductChangeProductone(e, i)}
                    placeholder="Price"
                  />
                </Col>

                <Col className="mb-1" lg="2" md="3" sm="12">
                  <Label>Req_Qty</Label>
                  <Input
                    type="number"
                    min={0}
                    step="any"
                    name="RequiredQty"
                    value={row?.RequiredQty || ""}
                    onChange={(e) => handleProductChangeProductone(e, i)}
                    placeholder="Req_Qty"
                  />
                </Col>

                <Col className="mb-1" lg="2" md="3" sm="12">
                  <Label>Total Price</Label>
                  <Input
                    type="number"
                    name="totalprice"
                    readOnly
                    value={
                      Number(row?.price || 0) * Number(row?.RequiredQty || 0)
                    }
                    placeholder="TtlPrice"
                  />
                </Col>

                <Col className="mb-1" lg="2" md="3" sm="12">
                  <Label>Waste Unit</Label>
                  <select
                    required
                    className="form-control"
                    name="WasteUnit"
                    value={row?.WasteUnit || ""}
                    onChange={(e) => handleProductChangeProductTwo(e, i)}
                  >
                    <option value="">--select Unit--</option>
                    <option value="kg">Kilogram (kg)</option>
                    <option value="Pcs">Pieces (Pcs)</option>
                    <option value="g">Gram (g)</option>
                    <option value="tonne">Metric Ton (tonne)</option>
                    <option value="m">Meter (m)</option>
                    <option value="cm">Centimeter (cm)</option>
                    <option value="mm">Millimeter (mm)</option>
                    <option value="in">Inch (in)</option>
                    <option value="ft">Foot (ft)</option>
                    <option value="m3">Cubic Meter (m³)</option>
                    <option value="L">Liter (L)</option>
                    <option value="ml">Milliliter (ml)</option>
                    <option value="s">Second (s)</option>
                    <option value="min">Minute (min)</option>
                    <option value="hr">Hour (hr)</option>
                    <option value="°C">Celsius (°C)</option>
                    <option value="°F">Fahrenheit (°F)</option>
                    <option value="Pa">Pascal (Pa)</option>
                    <option value="bar">Bar (bar)</option>
                    <option value="m/s">Meters per Second (m/s)</option>
                    <option value="km/h">Kilometers per Hour (km/h)</option>
                    <option value="A">Ampere (A)</option>
                    <option value="V">Volt (V)</option>
                    <option value="W">Watt (W)</option>
                    <option value="kW">Kilowatt (kW)</option>
                  </select>
                </Col>

                <Col className="mb-1" lg="2" md="3" sm="12">
                  <Label>Waste_Qty</Label>
                  <Input
                    type="number"
                    min={0}
                    step="any"
                    name="Waste_Qty"
                    value={row?.Waste_Qty || ""}
                    onChange={(e) => handleProductChangeProductone(e, i)}
                    placeholder="Waste_Qty"
                  />
                </Col>

                <Col className="mb-1" lg="2" md="3" sm="12">
                  <Label>Total</Label>
                  <Input
                    type="number"
                    name="WastePrice"
                    readOnly
                    value={
                      Number(row?.price || 0) * Number(row?.Waste_Qty || 0)
                    }
                    placeholder="WasteTotal"
                  />
                </Col>

                <Col className="d-flex mt-1" lg="3" md="12" sm="12">
                  {i > 0 && (
                    <Button color="danger" onClick={() => removeMoreProduct(i)}>
                      - Remove
                    </Button>
                  )}
                  <Button
                    className="ml-1"
                    color="primary"
                    onClick={addMoreProduct}
                  >
                    + Add
                  </Button>
                </Col>
              </Row>
            ))}

            <Row>
              <Col lg="12" md="12" sm="12">
                <div className="d-flex justify-content-end">
                  <Label className="pr-5 m-0">
                    Grand Total:&nbsp;
                    <strong>
                      {grandTotalAmt && String(grandTotalAmt) === "NaN"
                        ? 0
                        : grandTotalAmt}
                    </strong>
                  </Label>
                </div>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col className="d-flex justify-content-center">
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>

      {/* Charges Modal */}
      <Modal
        style={{ maxWidth: "1050px" }}
        isOpen={modalOne}
        toggle={toggleOne}
        {...args}
      >
        <ModalHeader toggle={toggleOne}>Add Charges</ModalHeader>
        <ModalBody>
          <Form className="m-1" onSubmit={submitHandler}>
            <Row>
              <Col className="mb-1" lg="3" md="3" sm="12">
                <Label>Miscellaneous Expenses</Label>
                <input
                  className="form-control"
                  name="Other_Expenses"
                  value={ExtraCharges?.Other_Expenses}
                  onChange={handleExtraCharge}
                  type="number"
                />
              </Col>
              <Col className="mb-1" lg="3" md="3" sm="12">
                <Label>GST Applied</Label>
                <Input
                  className="form-control"
                  type="select"
                  name="GSTApplied"
                  value={ExtraCharges?.GSTApplied}
                  onChange={handleExtraCharge}
                >
                  <option>--select--</option>
                  <option value={18}>18</option>
                  <option value={9}>9</option>
                </Input>
              </Col>
              <Col className="mb-1" lg="3" md="3" sm="12">
                <Label>Other Charges</Label>
                <input
                  className="form-control"
                  name="Other_charges"
                  value={ExtraCharges?.Other_charges}
                  onChange={handleExtraCharge}
                  type="number"
                />
              </Col>
              {/* <Col className="mb-1" lg="3" md="3" sm="12">
                <Label>Discount</Label>
                <input
                  className="form-control"
                  name="discount"
                  value={ExtraCharges?.discount}
                  onChange={handleExtraCharge}
                  type="number"
                />
              </Col> */}
            </Row>

            <Row>
              <Col>
                <div className="d-flex justify-content-end">
                  <strong>SubTotal:&nbsp;</strong>
                  {grandTotalAmt && String(grandTotalAmt) === "NaN"
                    ? 0
                    : grandTotalAmt}
                </div>
                <div className="d-flex justify-content-end">
                  <strong>Miscellaneous:&nbsp;</strong>
                  {ExtraCharges?.Other_Expenses}
                </div>
                <div className="d-flex justify-content-end">
                  <strong>GST:&nbsp;</strong>
                  {(
                    (Number(ExtraCharges?.GSTApplied || 0) *
                      Number(grandTotalAmt || 0)) /
                    100
                  ).toFixed(2)}
                </div>
                <div className="d-flex justify-content-end">
                  <strong>Other:&nbsp;</strong>
                  {ExtraCharges?.Other_charges}
                </div>
                <div className="d-flex justify-content-end">
                  <strong>Discount:&nbsp;</strong>
                  {ExtraCharges?.discount}
                </div>
                <div className="d-flex justify-content-end">
                  <strong>GrandTotal:&nbsp;</strong>
                  {(
                    Number(grandTotalAmt || 0) +
                    Number(ExtraCharges?.Other_Expenses || 0) +
                    Number(ExtraCharges?.Other_charges || 0) +
                    (Number(grandTotalAmt || 0) *
                      Number(ExtraCharges?.GSTApplied || 0)) /
                      100
                  ).toFixed(2)}
                </div>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col className="d-flex justify-content-center">
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter />
      </Modal>
    </div>
  );
};

export default StartProductionProcess;
